<template>
  <div class="link">
    Your referral link is
    <span class="url" @click="copyToClipboard">
      {{ link }}
    </span>
    <div @click="copyToClipboard">
      <img src="@/apps/traforama/assets/icons/copy-content.png" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useUserStore } from '@/store/modules/user'
import copy from 'copy-to-clipboard'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'ReferralLink',
  props: {
    domain: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { referrerCode } = useUserStore()

    const link = computed(() => {
      return `https://www.${props.domain}.com/?u=${referrerCode}`
    })

    const copyToClipboard = function () {
      copy(link.value)
      ElMessage.success('Copied!')
    }

    return { link, copyToClipboard }
  }
})
</script>
